import { findCommonRatioString } from './CommonRatios'
import { isAspectRatioObject, isPositiveNumber } from './guards'
import { calculateAspectRatioString, rountToTwo } from './helpers'
import type { AspectRatio, AspectRatioRange } from './types'

export const getAspectRatio = (ratio: unknown): number => {
  if (isPositiveNumber(ratio)) {
    return rountToTwo(ratio)
  }

  if (!isAspectRatioObject(ratio)) {
    throw new Error(`Invalid ratio: ${JSON.stringify(ratio)}`)
  }

  return rountToTwo(ratio.width / ratio.height)
}

export const getAspectRatioString = (
  ratio: AspectRatio | AspectRatio[],
): string => {
  if (Array.isArray(ratio)) {
    return ratio.map(getAspectRatioString).join(', ')
  }

  if (isPositiveNumber(ratio)) {
    return findCommonRatioString(ratio) ?? `${ratio}:1`
  }

  // ratio is a { width, height, ratio } object
  return ratio.readable
    ? ratio.readable
    : calculateAspectRatioString(ratio.width, ratio.height)
}

export const isRatioWithinRange = ({
  ratio,
  range,
}: {
  ratio: number
  range: AspectRatioRange
}): boolean => {
  const { minRatio, maxRatio } = range

  return ratio >= getAspectRatio(minRatio) && ratio <= getAspectRatio(maxRatio)
}
